import type { ProjectRepository } from '../repository/ProjectRepository';
import type { ProjectsSearchCommand, ProjectsSearchResponse } from '../entity/ProjectTypes';

export class SearchProjectsUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectsSearchCommand): Promise<ProjectsSearchResponse> {
    // validate/normalize (TDD target)
    if (!Number.isFinite(command.limit) || command.limit < 0) {
      throw new Error('limit must be a non-negative number');
    }
    if (!Array.isArray(command.params)) {
      throw new Error('params must be an array');
    }
    // default sort can be applied by caller; we keep usecase generic
    return this.repository.searchProjects(command);
  }
}


